import { Popover } from "@mui/material";
import { useState } from "react";
import { tv } from "tailwind-variants";

interface Props {
  color: "red" | "blue" | "yellow" | "green"
  title: string,
  description: string
}


function ItemStatus({ color, title, description }: Props) {
  const { bg, text } = tv({
    slots: {
      bg: "w-7 h-7 flex items-center justify-center rounded-[4px] cursor-pointer",
      text: "font-semibold"
    },
    variants: {
      color: {
        red: {
          bg: "bg-red-500",
          text: "text-white"
        },
        blue: {
          bg: "bg-blue-500",
          text: "text-white"
        },
        yellow: {
          bg: "bg-yellow-400",
          text: "text-black"
        },
        green: {
          bg: "bg-primary-green",
          text: "text-white"
        },
      }
    }
  })()

  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)

  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handlePopoverClose = () => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)

  return (
    <>
      <div
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
        className={bg({ color: color })}>
        <h1 className={text({ color: color })}>{title}</h1>
      </div>
      <Popover
        id="mouse-over-popover"
        sx={{ pointerEvents: 'none' }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        <p className="p-3 text-sm">{description}</p>
      </Popover>
    </>
  );
}

export default ItemStatus;